import {connect} from "react-redux"
import State from "../../models/State"

const mapStateToProps = (state: State) => ({
    url: state.request.url,
    enableSearchBannerTemplating: state.search.enableSearchBannerTemplating,
    templating: state.template,
})

export default connect(mapStateToProps)
